export default __webpack_public_path__ + "static/media/1minutepay.9dc4380b.png";